import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-pre-merchandise-location',
  templateUrl: './pre-merchandise-location.component.html',
  styleUrls: ['./pre-merchandise-location.component.scss']
})
export class PreMerchandiseLocationComponent implements OnInit {

  rack: string;

  constructor(public dialogRef: MatDialogRef<PreMerchandiseLocationComponent>) { }

  ngOnInit() {
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

}
